import { render, staticRenderFns } from "./DrawingUploadDialog.vue?vue&type=template&id=06e8c707"
import script from "./DrawingUploadDialog.vue?vue&type=script&lang=ts"
export * from "./DrawingUploadDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports